/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemovePluginServerSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RemovePluginServerRequest = {
  /**
   * The plugin server ID to remove.
   */
  id: string;
  pluginId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RemovePluginServerSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RemovePluginServerSecurity$outboundSchema: z.ZodMiniType<
  RemovePluginServerSecurity$Outbound,
  RemovePluginServerSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removePluginServerSecurityToJSON(
  removePluginServerSecurity: RemovePluginServerSecurity,
): string {
  return JSON.stringify(
    RemovePluginServerSecurity$outboundSchema.parse(removePluginServerSecurity),
  );
}

/** @internal */
export type RemovePluginServerRequest$Outbound = {
  id: string;
  plugin_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RemovePluginServerRequest$outboundSchema: z.ZodMiniType<
  RemovePluginServerRequest$Outbound,
  RemovePluginServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    pluginId: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      pluginId: "plugin_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function removePluginServerRequestToJSON(
  removePluginServerRequest: RemovePluginServerRequest,
): string {
  return JSON.stringify(
    RemovePluginServerRequest$outboundSchema.parse(removePluginServerRequest),
  );
}
